module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "content",
    attrs: {
      "id": "lifeCategoryView"
    }
  }, [_vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      attrs: {
        "gutter": 16
      }
    }, _vm._l((chunks), function(post, index) {
      return _c('mu-flexbox-item', {
        key: 'post-' + index,
        staticClass: "post"
      }, [_c('mu-card', [_c('router-link', {
        attrs: {
          "to": {
            name: 'LifeStyleArticle',
            params: {
              permalink: post.post_slug
            }
          }
        }
      }, [_c('mu-card-media', {
        staticClass: "imgHolder"
      }, [_c('div', {
        staticClass: "img",
        style: ({
          'background-image': 'url(' + post.post_image + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "overlay"
      }, [_c('mu-flexbox', {
        staticClass: "item",
        attrs: {
          "justify": "flex-end",
          "align": "align"
        }
      }, [_c('h3', {
        staticClass: "largeTitle"
      }, [(_vm.isHcpView) ? _vm._o(_c('span', [_vm._v(_vm._s(_vm.truncate(post.post_title)))]), 0, 'post-' + index) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('span', [_vm._v(_vm._s(post.post_title))]) : _vm._e()]), _vm._v(" "), _c('mu-card-text', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "extract"
      }, [_c('div', [_vm._v(_vm._s(post.post_excerpt) + "\n                        ")])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "stats-bar"
      }, [_c('div', {
        staticClass: "stat favourites"
      }, [_c('mu-icon-button', {
        attrs: {
          "icon": post.post_favourited ? 'favorite' : 'favorite_border',
          "disabled": _vm.userId === false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.favouritePost(post.post_id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        domProps: {
          "textContent": _vm._s(post.post_favourites)
        }
      })], 1)])], 1)], 1)
    }), 1)
  }), _vm._v(" "), (!_vm.isPostsFinished) ? _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "full-width": "",
      "disabled": _vm.isAppending || _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.loadCatPosts(_vm.getPostParams, _vm.termId, 'append')
      }
    }
  }, [_vm._v(_vm._s(_vm.isAppending ? 'Loading...' : 'Load more'))]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115d6ad9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LifeStyle/Category/LifeCategory.vue
// module id = 3605
// module chunks = 1